import { ReactEditor, useSlateStatic } from 'slate-react'
import { Transforms } from 'slate'
import { bool, func } from 'prop-types'
import { camelCase } from 'lodash-es'
import { useContext } from 'react'
import cc from 'classcat'

import { BASE_BLOCK_ELEMENT_TYPES } from '../serialization'
import { ToolbarContext } from '../RichTextEditor'
import { getBaseBlockElementType } from '../base_block_elements'
import { getList } from '../lists'

export default function BaseBlockElementsDropdown({ t, isHeadline }) {
  const editor = useSlateStatic()
  const [{ isBaseBlockElementsDropdownOpen: isOpen }, toolbarDispatch] = useContext(ToolbarContext)
  const lastSelection = editor.useLastSelection(editor)

  const { isList } = getList(editor)

  const fallback = isHeadline ? 'headline2' : 'paragraph'
  const baseBlockElementType = getBaseBlockElementType(editor, editor.selection || lastSelection.current) || fallback

  function handleCommandSelect(type) {
    Transforms.setNodes(editor, { type })
    ReactEditor.focus(editor)
    toolbarDispatch({ type: 'close_base_block_elements_dropdown' })
  }

  return (
    <div className={cc(['dali-plugin-text-toolbar-dropdown', { open: isOpen }])}>
      <button
        title={t('baseBlockElementsDropdown.explanation')}
        data-command-name="open-dropdown"
        onClick={() => {
          if (!editor.selection) Transforms.select(editor, lastSelection.current)
          toolbarDispatch({ type: 'toggle_base_block_elements_dropdown' })
        }}
        className="dali-plugin-text-toolbar-dropdown-button"
      >
        <span className="dali-plugin-text-toolbar-dropdown-active">
          {t(`baseBlockElementsDropdown.options.${camelCase(baseBlockElementType)}`)}
        </span>
        <span className="dali-plugin-text-toolbar-dropdown-caret" />
      </button>
      <ul role="menu">
        {BASE_BLOCK_ELEMENT_TYPES.map((type) =>
          isHeadline && type === 'paragraph' ? null : (
            <li key={type}>
              <button
                onClick={() => handleCommandSelect(type)}
                data-command-name={type}
                className={cc(['dali-plugin-text-toolbar-dropdown-button', { active: type === baseBlockElementType }])}
                disabled={isList}
              >
                {t(`baseBlockElementsDropdown.options.${camelCase(type)}`)}
              </button>
            </li>
          ),
        )}
      </ul>
    </div>
  )
}

BaseBlockElementsDropdown.propTypes = { t: func.isRequired, isHeadline: bool }
